export const formatDate = (isoDate: string) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("es-MX", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
};

export const formatPaymentMethod = (method: string | undefined) => {
  
    if (!method) return "Desconocido";
  
    const cleanMethod = method.toLowerCase().trim();
  
    switch (cleanMethod) {
      case "transferencia":
        return "Transferencia";
      case "deposito":
        return "Depósito";
      case "stripe":
        return "Stripe";
      default:
        return "Desconocido";
    }
};

export interface IExtraordinaryPayment {
    paid: boolean;
    paidAt: string;
    amount: number;
    paymentMethod: string;
    referenceNumber: string;
}